import React, { createContext, useContext } from "react";
import { Link } from "react-router-dom";
import firebase from "firebase/app";
import { UserContext } from "../../../../App";
import './Navbar.css'


const Navbar = () => {

  const [logInUser,setLogInUser] =useContext(UserContext);
  const handleLogOut = () => {
    firebase.auth().signOut()
    sessionStorage.removeItem('token')
  }
console.log(logInUser)
  let button 
  if(logInUser.name){
    button = <button href="/" onClick={handleLogOut} class="btn btn-primary">Log out</button>
  }else{
    button = <Link to="/login"><button class="btn btn-primary">Login</button></Link>
  }
  return (
    <div className="Navbar">
      <ul >
        <li >
          <a href="/">Home</a>
        </li>

        <li ><Link to="/dashboard">
          Dashboard</Link>
        </li>
        <li >
          {button}
        </li>
      </ul>    
    </div>
  );
};

export default Navbar;
